import React from 'react';
import { Link } from 'gatsby';
import { BreakpointContext, useBreakpoints } from 'react-use-breakpoints';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { Text } from '../Text';
import { StyledEmployerCard } from './styles';
import { Button } from '../Button';
import { AvatarSquare } from '../AvatarSquare';

interface IEmployerCard {
  name: string;
  role: string;
  client: string;
  clientSlug: string;
  imageUrl: any;
  alt?: string;
  className?: string;
  linkedInUrl?: string;
}

export const EmployerCard = ({
  name,
  role,
  client,
  clientSlug,
  imageUrl,
  alt,
  className,
  linkedInUrl,
}: IEmployerCard) => {
  const breakpoints = React.useContext(BreakpointContext);
  const { breakpoint } = useBreakpoints(breakpoints);
  const isUnderTablet = [`watch`, `phone`, `phablet`, `tablet`].some(
    (item) => item === breakpoint,
  );
  return (
    <StyledEmployerCard className={className}>
      <div className="employer__container">
        <AvatarSquare
          imageUrl={imageUrl}
          disableLink
          alt={alt}
          size={isUnderTablet ? `xl` : `xxl`}
          className="employer-layout__avatar"
        />
        <div className="employer-layout__content">
          <div className="content__top">
            <div className="name">
              <div className="name__left">
                <Text
                  noRhythem
                  type="title3"
                  color="gray_3"
                  className="name__text"
                >
                  {name}
                </Text>
              </div>
              {linkedInUrl ? (
                <div className="name__right">
                  <div className="social">
                    <Link target="_blank" to={linkedInUrl}>
                      <Button size="small" disabled={false}>
                        <FontAwesomeIcon
                          size="sm"
                          className="link__icon"
                          icon={faLinkedinIn}
                        />
                      </Button>
                    </Link>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
          <div className="content__bot">
            <div className="content__bot-item">
              <Text noRhythem type="body3" color="gray_3_65">
                Role
              </Text>
              <Text noRhythem type="body3" color="gray_3">
                {role}
              </Text>
            </div>

            <div className="content__bot-item">
              <Text noRhythem type="body3" color="gray_3_65">
                Client
              </Text>
              <Link to={`projects/${clientSlug}`}>
                <Button className="client--button" size="xsmall" noBg contrast>
                  {client}
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </StyledEmployerCard>
  );
};
